// @ts-nocheck
import React from 'react';
import { Popper } from '@mui/material';

const CustomPopover = (props) => {
  return (
    <Popper
      style={{
        width: 450,
        maxWidth: 450,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      }}
      placement="bottom"
      popperOptions={{
        modifiers: [
          {
            name: 'sameWidth',
            enabled: true,
            phase: 'beforeWrite',
            requires: ['computeStyles'],
            fn: ({ state }) => {
              Object.assign(state?.styles?.popper, {
                width: `${state?.rects?.reference?.width}px`,
              });
            },
          },
        ],
      }}
      {...props}
    />
  );
};

export default CustomPopover;
